import { Box, Typography } from "@mui/material";

import LoginPepsiSvg from "./LoginPepsiSvg";

const LoginFooter = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" }, // Column on small screens, row on medium and larger
        gap: { xs: "16px" }, // Gap for small screens
        justifyContent: "space-between",
        bgcolor: "black", // Background color
        width: "100%", // Set width responsively
        padding: 2, // Responsive padding
        height: "auto", // Responsive height
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "131px",
          height: "37px",
        }}
      >
        <LoginPepsiSvg />
      </Box>

      <Box sx={{ color: "white", textAlign: { xs: "left", md: "right" } }}>
        <Typography
          sx={{
            color: "var(--PepsiCo-White, #FFF)", // Text color
            fontFeatureSettings: "'liga' off, 'clig' off", // Font feature settings
            fontFamily: "var(--Typography-Font-Family-Body, Inter)", // Font family
            fontSize: "var(--Font-Size-XSmall, 12px)", // Font size
            fontStyle: "normal", // Font style
            fontWeight: 400, // Font weight
            lineHeight: "var(--Line-Height-XSmall, 18px)", // Line height
          }}
        >
          Disclaimer: The information provided herein is for general guidance
          only and does not constitute professional agricultural advice. You are
          solely responsible for any reliance on this information. PepsiCo, Inc.
          does not make any warranties, express or implied, regarding the
          accuracy, completeness, or suitability of this information for any
          particular purpose. Nor is PepsiCo liable for any damages or losses
          arising from the use of this information. The user is solely
          responsible for any reliance on this information and for making their
          own independent assessment and investigation. For specific advice
          tailored to your needs, please consult with a qualified professional.
          The user is responsible for complying with all applicable laws and
          regulations, including is responsible for obtaining any necessary
          permits or license.
        </Typography>
        <Typography
          sx={{
            color: "var(--PepsiCo-White, #FFF)", // Text color
            fontFeatureSettings: "'liga' off, 'clig' off", // Font feature settings
            fontFamily: "var(--Typography-Font-Family-Body, Inter)", // Font family
            fontSize: "var(--Font-Size-XSmall, 12px)", // Font size
            fontStyle: "normal", // Font style
            fontWeight: 400, // Font weight
            lineHeight: "var(--Line-Height-XSmall, 18px)", // Line height
          }}
        >
          <span style={{ display: "inline-block", textAlign: "right" }}>
            ©{new Date().getFullYear()} Pepsico, Inc. All Rights Reserved.
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginFooter;
